import React from 'react';

export default ({ children, href, target = '_blank' }) => (
  <a href={href} target={target} rel="noopener noreferrer">
    {children}
  </a>
);



// WEBPACK FOOTER //
// ./src/components/SafeLink.js